import { useEffect } from 'react';

import { useDataFlow } from '@apis/rendall/queries/use-data-flow';

import type { FlowDataType } from '../../../flow-data-type';
import { useFlowDataRequest } from '../../../hooks/use-flow-data-request/use-flow-data-request';
import type { Option } from '../use-option-cache/use-option-cache';
import { useOptionCache } from '../use-option-cache/use-option-cache';

export const useDataFlowResponseOptions = (
  flowDataType: FlowDataType | null,
  initialOptions?: Option[],
) => {
  const request = useFlowDataRequest();
  const { data, isFetching } = useDataFlow(request);

  const optionCache = useOptionCache(initialOptions);
  const { addToCache } = optionCache;

  const isDataRelevant = request.type === flowDataType && !isFetching;
  useEffect(() => {
    if (!isDataRelevant || !(data?.results ?? [])?.length) {
      return;
    }

    const optionsToAdd = (data?.results ?? []).map(({ name }) => ({
      value: name,
      label: name,
    }));

    addToCache(optionsToAdd);
  }, [addToCache, data, isDataRelevant]);

  return optionCache;
};
